import {
  createContext,
  useState,
  ReactNode,
  useCallback,
  useEffect,
} from "react";
import { Box, CircularProgress } from "@mui/material";
import API from "../api/api";

type PortalConfig = {
  partialPayments: boolean;
  unsortedPayments: boolean;
  guestPayments: boolean;
  login: boolean;
};

const defaultConfig: PortalConfig = {
  partialPayments: false,
  unsortedPayments: false,
  guestPayments: false,
  login: false,
};

export const PortalConfigContext = createContext<PortalConfig>(defaultConfig);

type PortalConfigProviderProps = {
  children: ReactNode;
};

const PortalConfigProvider = ({ children }: PortalConfigProviderProps) => {
  const [configs, setConfigs] = useState<PortalConfig>(defaultConfig);
  const [mounted, setMounted] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchConfigs = useCallback(async () => {
    setLoading(true);
    const response = await API.get<PortalConfig>("/portal-config");
    setConfigs(response?.data || defaultConfig);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!mounted) {
      fetchConfigs();
      setMounted(true);
    }
  }, [mounted, fetchConfigs]);

  return (
    <PortalConfigContext.Provider value={configs}>
      {!loading ? (
        children
      ) : (
        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100dvh"
        >
          <CircularProgress size={60} />
        </Box>
      )}
    </PortalConfigContext.Provider>
  );
};

export default PortalConfigProvider;
